<form class="app-form">
  <div class="setup-content" id="step-4">
    <h4>{{ 'MESSAGES.INFOS.LETS_KEEP_YOU_SECURE' | translate }}</h4>
    <p>{{ 'MESSAGES.PROMPTS.CREATE_4DIGIT_PIN' | translate }}</p>
    <div class="form-group">
      <label class="col-form-label">{{ 'LABELS.PASSWORD' | translate }}</label>
      <div class="pin">
        <code-input
          class="code-input"
          id="passcode"
          [isCodeHidden]="true"
          [codeLength]="4"
          (codeChanged)="enterPasscode($event)"
        >
        </code-input>
      </div>
    </div>
    <div class="form-group">
      <label class="col-form-label">{{ 'LABELS.CONFIRM_PASSWORD' | translate }}</label>
      <div class="pin">
        <code-input
          class="code-input"
          id="confirmPasscode"
          [isCodeHidden]="true"
          [codeLength]="4"
          (codeChanged)="enterConfirmPasscode($event)"
        >
        </code-input>
      </div>
      @if (!passcodeValue().valid) {
      <div class="invalid">{{ 'MESSAGES.ERRORS.PASSWORDS_DO_NOT_MATCH' | translate }}</div>
      }
    </div>
    <div class="form-group mb-0">
      <button
        class="btn btn-gradient float-right mt-4"
        type="button"
        (click)="createAccount()"
        [disabled]="!passcodeValue().valid"
      >
        {{ 'LABELS.CREATE_ACCOUNT' | translate }}
      </button>
      <button class="btn btn-outline-secondary float-right mr-4 mt-4" type="button" (click)="back.emit()">
        {{ 'LABELS.BACK' | translate }}
      </button>
    </div>
  </div>
</form>
